"use strict";

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.zillow = void 0;
/* eslint-disable max-len */

var react_1 = __importDefault(require("react"));

var classnames_1 = __importDefault(require("classnames"));

var zillow = function zillow(_a) {
  var className = _a.className,
      rest = __rest(_a, ["className"]);

  var classes = (0, classnames_1["default"])('helix-icon', 'zillow-outlined', className);
  return react_1["default"].createElement("svg", Object.assign({
    className: classes,
    width: '20',
    height: '20',
    viewBox: '0 0 20 20',
    fill: 'none',
    xmlns: 'http://www.w3.org/2000/svg',
    "aria-hidden": 'true'
  }, rest), react_1["default"].createElement("path", {
    d: 'M6.77554 15.8157C6.71722 15.8462 6.66972 15.8385 6.62281 15.7928L5.3174 14.2756C5.28252 14.2334 5.27831 14.2105 5.32522 14.146C6.33419 12.7051 8.39363 10.4595 9.70687 9.5106C9.73032 9.49535 9.7225 9.47599 9.69484 9.48772C8.32689 9.92229 4.4383 11.5538 3 12.3467V17.5H16.9964V12.5373C15.0891 12.8534 9.37495 14.512 6.77554 15.8157V15.8157ZM12.4662 6.54485C12.5366 6.5296 12.5678 6.55247 12.6105 6.59821C12.8529 6.86095 13.6273 7.78346 13.8378 8.03505C13.8769 8.0808 13.8498 8.13065 13.8185 8.15704C12.2552 9.34639 10.5156 11.0313 9.54632 12.2359C9.52708 12.2629 9.54271 12.2629 9.55835 12.2588C11.2468 11.5497 15.2135 10.4173 17 10.1012V7.8943L10.0081 2.5L3.00421 7.8902V10.3029C5.17309 9.04553 10.1915 7.09729 12.4662 6.54485V6.54485Z',
    fill: '#4B5563'
  }));
};

exports.zillow = zillow;